import request from '@/utils/request'

// 预约列表
export function appointList(data) {
  return request({
    url: '/health-cure/cure/reserve/v2/list',
    method: 'get',
    params: data
  })
}
// 根据医生id 获取医生所在医院配置 Copy
export function getDoctorHospitalSetting(data) {
  return request({
    url: '/health-doctor/user/getDoctorHospitalSetting',
    method: 'get',
    params: data
  })
}
// 预约详情 通过id
export function appointRecordIdApi(data) {
  return request({
    url: '/health-cure/cure/reserve/v2/detail',
    method: 'get',
    params: data
  })
}
// 预约详情 通过id
export function AItrackList(data) {
  return request({
    url: '/health-doctor-assistant/ai/track/list',
    method: 'get',
    params: data
  })
}

// 预约详情 通过订单号
export function appointReserveSnApi(data) {
  return request({
    url: '/health-cure/cure/reserve/jumpDetails',
    method: 'get',
    params: data
  })
}

export function submitAppoint(data) {
  return request({
    url: '/health-cure/cure/reserve/v2/submit',
    method: 'post',
    data
  })
}

export function getAppointDate(data) {
  return request({
    url: '/health-cure/cure/consult/getFutureVisitAndNumInfo',
    method: 'get',
    params: data
  })
}
export function getV2AppointDate(data) {
  return request({
    url: '/health-cure/cure/consult/v2/getFutureVisitAndNumInfo',
    method: 'get',
    params: data
  })
}
export function preBaseAppointInfo(data) {
  return request({
    url: '/health-cure/cure/reserve/baseInfo',
    method: 'get',
    params: data
  })
}

export function saveReserveSetting(data) {
  return request({
    url: '/health-doctor/user/saveReserveSetting',
    method: 'post',
    data
  })
}

// export function saveReserveSetting(data) {
//   return axios({
//     method: 'post',
//     headers: {
//       [TokenKey]: getToken(),
//       'content-type': 'multipart/form-data'
//     },
//     data,
//     url: `${process.env.VUE_APP_BASE_API}/health-doctor/user/saveReserveSetting`
//   })
// }

export function checkReserveFlag(data) {
  return request({
    url: '/health-doctor/user/checkReserveFlag',
    method: 'get',
    params: data
  })
}

export function apiReserveAndNum(data) {
  return request({
    url: '/health-doctor/user/getReserveAndNum',
    method: 'get',
    params: data
  })
}
// 弹窗前置查询接口
export function queryExistCureReserve(data) {
  return request({
    url: '/health-cure/cure/reserve/queryExistCureReserve',
    method: 'get',
    params: data
  })
}

//编辑医生坐诊机构排班
export function updateDrOutpatientInfo(data) {
  return request({
    url: '/health-doctor/drOutpatientInfo/update',
    method: 'post',
    data
  })
}
//门诊排班操作记录-查询最新一条
export function getDrOutpatientInfoLog(data) {
  return request({
    url: '/health-doctor/drOutpatientInfo/operationRecord/latest',
    method: 'post',
    data
  })
}
